import { type ReactElement } from 'react'
import { isNotEmpty } from '@terros/common'
import { createFileRoute } from '@tanstack/react-router'
import { useCanAddWorkflow, useTranslation, useWorkflowFeature, useWorkflows } from '@front/model'
import { NotReady, Page } from '@components'
import { WorkflowList } from './WorkflowList'
import { AddWorkflowHero } from './AddNewWorkflowHero'
import { AddWorkflow } from './add'

function WorkflowPage(): ReactElement {
  const { isEnabled: isWorkflowEnabled, isLoading: isLoadingFeature } = useWorkflowFeature()
  const { t } = useTranslation()
  const { data, isLoading, error, ...state } = useWorkflows()
  const canAddWorkflow = useCanAddWorkflow()

  if (isLoading || isLoadingFeature) return <NotReady isLoading={isLoading || isLoadingFeature} />
  if (!isWorkflowEnabled) return <NotReady error={t('Workflows are not available')} />

  return (
    <Page>
      <Page.Heading title={t('Workflows')} {...state}>
        {canAddWorkflow && isNotEmpty(data) && <AddWorkflow />}
      </Page.Heading>
      <Page.Content scrollArea>
        {isNotEmpty(data) ? <WorkflowList workflows={data} /> : <AddWorkflowHero />}
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/settings/workflow/')({
  component: WorkflowPage,
})
